import { Link } from 'react-router-dom'
import type { Story, StoryQuest } from '@mezha/api'
import { Emblem } from '../ui/brand/Emblems'
import { Pips } from '../ui'
import { currentStoryQuest } from '../screens/questNavigation'

/** The quest shown on the scene: the first active one, else the first to claim. */
export function currentQuest(story: Story | undefined): StoryQuest | null {
  return currentStoryQuest(story)
}

type Props = { story: Story | undefined; loading: boolean; failed: boolean; line: boolean }

/** Journal slot: parchment sheet on the scene, a single lintel line over windows. */
export function QuestSlot({ story, loading, failed, line }: Props) {
  const q = currentQuest(story)
  const title = line && q ? q.title : 'Дорожный журнал'
  const label = q ? `Журнал: ${q.title}, ${q.step_index} из ${q.step_count}` : 'Журнал'
  return (
    <div className={line ? 'quest quest--line' : 'quest'}>
      <div className="quest__seal" aria-hidden="true"><Emblem name="nav.journal" size={20} style={{ filter: 'none' }} /></div>
      <div className="quest__lintel">
        <Link className="plank quest__open" to="/play/journal" aria-label={label}>
          <span className="plank__in">
            <span className="quest__title">{title}</span>
            {line && q && <Pips total={q.step_count} done={q.step_index} />}
          </span>
        </Link>
      </div>
      {!line && (
        <div className="quest__sheet parch">
          <div className="qitem">
            <div className="qitem__rune" aria-hidden="true"><Emblem name={q ? 'loc.inspect' : 'nav.journal'} size={12} /></div>
            <div className="qitem__text">
              {q ? (
                <>
                  <b>{q.title}</b>
                  <span>{q.status === 'completed' ? 'Все шаги пройдены — заберите награду в журнале' : q.current ? `${q.current.title}: ${q.current.place_name}` : ''}</span>
                </>
              ) : (
                <b>{loading ? 'Загружаем журнал…' : failed ? 'Журнал недоступен' : 'Нет открытых заданий'}</b>
              )}
            </div>
            {q && <Pips total={q.step_count} done={q.step_index} />}
          </div>
        </div>
      )}
    </div>
  )
}
